import * as React from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  IconButton,
  TextField,
  Grid,
  MenuItem,
  styled,
  MenuProps,
  alpha,
  Menu,
  InputAdornment,
  Pagination,
  Stack,
  Backdrop,
  CircularProgress,
  useTheme,
  Checkbox,
  Typography,
  MenuList,
  Tooltip,
} from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import { useLocation, useNavigate } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";
import CustomColumn from "../../../../src/Assets/custom-column.svg";
import ClearIcon from "@mui/icons-material/Clear";
import LockIcon from "@mui/icons-material/Lock";
import { useEffect, useState } from "react";
import useMediaQuery from "@mui/material/useMediaQuery";
import AddIcon from "@mui/icons-material/Add";
import {
  GetList,
  GetStockBatchWiseList,
  getStockReportExportFile,
} from "../../../Services/StockService";
import { PAGE_SIZE } from "../../../Services/common/const";
import Title from "../../../Components/Title";
import ShortcutButton from "../../../Components/ShortcutButton";
import { PreferencesContext } from "../../../PreferencesContext";
import MissingConsumer from "../../../Components/MissingConsumer";
import {
  ExportFilesFunction,
  numberFormat,
} from "../../../shared/CommonFuctions";
import { KeyboardArrowDownSharp } from "@mui/icons-material";
import {
  GetStockBatchWiseListReport,
  GetStockReport,
} from "../../../Services/ReportService";
import KeyboardBackspaceRoundedIcon from "@mui/icons-material/KeyboardBackspaceRounded";
import SplashComponent from "../../../Navigation/splash";
import { AlertType } from "../../../shared/Modal/AlertType";
import { GetCategoryList } from "../../../Services/Category";
import MultiSelectSim from "../../../Components/MultiSelectSimple";
import { EncryptDecryptService } from "../../../Services/common/EncryptionService";
import { GetProductListforBatchwiseListReport } from "../../../Services/CategoryProductService";
import { format } from "date-fns";
import { clearScreenDown } from "readline";
import MultiSelect from "../../../Components/MultiSelect";
import { GetSupplierList } from "../../../Services/SupplierService";
import AsyncSelect from "react-select/async";
import { CreateConfiguration, GetSystemConfigurationById, UpdateConfiguration } from "../../../Services/SystemConfigurationService";
import { GetProductCompanyList } from "../../../Services/ProductCompanyService";
import makeAnimated from "react-select/animated";
import { BootstrapTooltip } from "../../../Components/BootStrapToolTip";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";

interface Data {
  id: number;
  code: string;
  Product: string;
  Availability: string;
  none: string;
}

function descendingComparator<T>(a: T, b: T, orderBy: keyof T) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

type Order = "asc" | "desc" | "";

function getComparator<Key extends keyof any>(
  order: Order,
  orderBy: Key
): (
  a: { [key in Key]: number | string },
  b: { [key in Key]: number | string }
) => number {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

// This method is created for cross-browser compatibility, if you don't
// need to support IE11, you can use Array.prototype.sort() directly
function stableSort<T>(
  array: readonly T[],
  comparator: (a: T, b: T) => number
) {
  const stabilizedThis = array.map((el, index) => [el, index] as [T, number]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

interface EnhancedTableProps {
  numSelected: number;
  order: Order;
  orderBy: String;
  rowCount: number;
  reportConfigDetail: any;
}

const stock: any = {
  batchWiseListCollection: [],
};
const parameters: any = {
  consumerId: 25,
  branchId: 1,
  pageIndex: 1,
  pageSize: PAGE_SIZE,
  sortColumn: "",
  sortDirection: "",
  isZeroAllowed: false,
  searchValue: "",
  lessThanValue: "",
};

export default function StockByProductReport() {
  const Stockdata = {
    title: "Stock",
    button: "Save",
    stockID: 0,
  };
  const theme = useTheme();
  const matches = useMediaQuery("(max-width:599px)");
  const match = useMediaQuery("(max-width:599px)");
  const mobileScreen = useMediaQuery(theme.breakpoints.down("sm"));

  let navigate = useNavigate();
  const [state, setState] = useState(Stockdata);
  const [param, setParam] = useState(parameters);
  const [anchorEl, setAnchorEl3] = React.useState<HTMLButtonElement | null>(
    null
  );
  const [stockID, setstockID] = React.useState(null);
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
  const [order, setOrder] = React.useState<Order>("");
  const [orderBy, setOrderBy] = React.useState<keyof Data>("none");
  const [selected, setSelected] = React.useState<readonly number[]>(
    stock.batchWiseListCollection
  );
  const [productCompanyCollection, setProductCompanyCollection] = useState<any>([]);
  const [productCompanySelectedOption, setProductCompanySelectedOption] =
    React.useState<any>("");
  const [selectedProductCompanyIdData, setSelectedProductCompanyIdData] =
    React.useState<any>("");
  const [inputCompanyValue, setInputCompanyValue] = useState("");
  const [selectedCompanies, setSelectedCompanies] = useState<any[]>([]);
  const [page, setPage] = React.useState(0);
  const [dense, setDense] = React.useState(false);
  const [rowsPerPage, setRowsPerPage] = React.useState(PAGE_SIZE);
  const [value, setValue] = useState("");
  const [values, setValues] = useState("");
  const [isLoading, setLoading] = React.useState(false);
  const [isAllowAdd, setAllowAdd] = React.useState(true);
  const [isSubmitting, setSubmitting] = React.useState(false);
  const [openDilog, setopenDilog] = React.useState(false);
  const [resultData, setResultData] = useState(stock);
  const [selectedProductIdData, setselectedProductIdData] = React.useState<any>(
    []
  );
  const [SourceSupplierCollection, setSourceSupplierCollection] = useState<any>([]);
  const [selectedSuppliersId, setSelectedSupplierId] = React.useState<any>([]);
  const [selectedSupplierIdData, setSelectedSupplierIdData] =
    React.useState<any>([]);
  const [productCollection, setProductCollection] = useState<any>([]);
  const [page_Index, setPage_Index] = useState(1);
  const [counData, setCounData] = useState(0);
  const [anchorEl2, setAnchorEl2] = React.useState<null | HTMLElement>(null);
  const [Curr_page, setCurrPage] = React.useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [pageStartIndex, setPageStartIndex] = useState(1);
  const [pageEndIndex, setPageEndIndex] = useState(1);
  const animatedComponents = makeAnimated();
  // const [categorysSelectedOption, setCategorysSelectedOption] = React.useState<any>([]);
  const [productsSelectedOption, setProductssSelectedOption] =
    React.useState<any>([]);

  const openExportType = Boolean(anchorEl2);
  const handleClickExportType = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl2(event.currentTarget);
  };
  const handleCloseExportType = () => {
    setAnchorEl2(null);
  };
  const { userContext, updateUserContext } =
    React.useContext(PreferencesContext);

  async function fetchProductCompanyList() {
    try {
      let params = new URLSearchParams();
      let companyList: any;
      params.append("consumerId", userContext.consumerId.toString());
      params.append("firmId", userContext.firmId.toString());
      params.append("branchId", userContext.branchId.toString());
      params.append("pageIndex", page_Index.toString());
      params.append("pageSize", param.pageSize);
      params.append("sortColumn", param.sortColumn);
      params.append("sortDirection", param.sortDirection);
      params.append("searchValue", param.searchValue);
      params.append("mode", "DROPDOWN");

      const result: any = await GetProductCompanyList(params);
      if (result && result.data.data) {
        companyList = result.data?.data?.productCompanyCollection;
        setProductCompanyCollection(companyList);
      } else {
      }
      return companyList;
    } catch (e: any) {
      updateUserContext({
        ...userContext,
        isAlert: true,
        alertMessage:
          typeof e === "string" ? (e as string) : (e?.message as string),
        alertType: AlertType.Error,
      });
    }
  }

  async function filterProductCompany(inputValue: string) {
    try {
      let params = new URLSearchParams();
      params.append("consumerId", userContext.consumerId.toString());
      params.append("firmId", userContext.firmId.toString());
      params.append("branchId", userContext.branchId.toString());
      params.append("pageIndex", "1");
      params.append("pageSize", "50");
      params.append("sortColumn", "");
      params.append("sortDirection", "");
      params.append("searchValue", inputValue);
      params.append("mode", "DROPDOWN");

      const result: any = await GetProductCompanyList(params);
      if (result && result.data.data) {
        return result.data?.data?.productCompanyCollection;
      }
      return [];
    } catch (e: any) {
      updateUserContext({
        ...userContext,
        isAlert: true,
        alertMessage:
          typeof e === "string" ? (e as string) : (e?.message as string),
        alertType: AlertType.Error,
      });
      return [];
    }
  }

  const loadFilterCompanyOptions = (
    inputValue: string,
    callback: (options: any) => void
  ) => {
    if (inputValue && inputValue.length > 0) {
      filterProductCompany(inputValue).then((r) => {
        callback(r);
      });
    } else {
      callback([]);
    }
  };

  async function fetchStockList() {
    //new http for API
    setLoading(true);
    let params = new URLSearchParams();
    params.append("consumerId", userContext.consumerId.toString());
    params.append("firmID", userContext.firmId.toString());
    params.append("branchID", userContext.branchId.toString());
    params.append("pageIndex", page_Index.toString());
    params.append("pageSize", param.pageSize);
    params.append("sortColumn", param.sortColumn);
    params.append("sortDirection", param.sortDirection);
    params.append("searchValue", param.searchValue);
    params.append("isZeroAllowed", param.isZeroAllowed);
    params.append("lessThanValue", param.lessThanValue);
    params.append("financialYear", userContext.financialYear);
    if (
      convertedProductId > 0 &&
      selectedProductIdData?.length === 0 &&
      productsSelectedOption?.length !== 0
    ) {
      params.append("productID", convertedProductId.toString());
    } else {
      params.append("productID", selectedProductIdData);
    }
    if (selectedProductCompanyIdData) {
      params.append("productCompanyIds", selectedProductCompanyIdData);
    }

    try {
      const result: any = await GetStockBatchWiseList(params);
      let endIndex: any;
      if (result && result.data.data) {
        let dataCount = result.data.data.totalCount;
        let StockInfo = result.data.data;
        let showDataCount = Math.ceil(dataCount / PAGE_SIZE);
        setResultData(StockInfo);
        setCounData(showDataCount);
        let startIndex = (page_Index - 1) * param.pageSize + 1;
        endIndex =
          (page_Index - 1) * param.pageSize +
          (result.data.data.batchWiseListCollection
            ? result.data.data.batchWiseListCollection.length
            : 0);
        setPageStartIndex(startIndex);
        setPageEndIndex(endIndex);
        setTotalCount(dataCount);
      } else {
        console.log("Error");
      }
      setLoading(false);
    } catch (e: any) {
      updateUserContext({
        ...userContext,
        isAlert: true,
        alertMessage:
          typeof e === "string" ? (e as string) : (e?.message as string),
        alertType: AlertType.Error,
      });
    }
  }

  // async function GetProductListforBatchwise() {
  //
  //     try {
  //         let params = new URLSearchParams();
  //         params.append("consumerId", userContext.consumerId.toString());
  //         params.append("firmId", userContext.firmId.toString());
  //         params.append("branchId", userContext.branchId.toString());
  //         params.append("sortColumn", param.sortColumn);
  //         params.append("sortDirection", param.sortDirection);
  //         params.append("searchValue", param.searchValue);

  //         const result: any = await GetProductListforBatchwiseList(params);
  //         console.log(result)
  //         if (result?.productCollection) {
  //             setProductCollection(result?.productCollection);
  //         } else {
  //         }
  //     } catch (e: any) {
  //         updateUserContext({
  //             ...userContext,
  //             isAlert: true,
  //             alertMessage: typeof e === 'string' ? e as string : e?.message as string,
  //             alertType: AlertType.Error,
  //         });
  //     }
  // }

  async function GetProductListforBatchwise() {
    setLoading(true);
    let params = new URLSearchParams();
    params.append("consumerId", userContext.consumerId.toString());
    params.append("firmId", userContext.firmId.toString());
    params.append("branchId", userContext.branchId.toString());
    params.append("sortColumn", param.sortColumn);
    params.append("sortDirection", param.sortDirection);
    params.append("searchValue", param.searchValue);
    try {
      let categoryInfo: any;
      const result: any = await GetProductListforBatchwiseListReport(params);
      if (result && result.data.data) {
        categoryInfo = result.data?.data?.productCollection;
        setProductCollection(categoryInfo);
      } else {
      }
      // setLoading(false);
      return categoryInfo;
    } catch (e: any) {
      setLoading(false);
      updateUserContext({
        ...userContext,
        isAlert: true,
        alertMessage:
          typeof e === "string" ? (e as string) : (e?.message as string),
        alertType: AlertType.Error,
      });
    }
  }

  async function GetSuppliersList(onInit, searchValue, id) {
    try {
      let params = new URLSearchParams();
      let supCollection: any;
      params.append("consumerId", userContext.consumerId.toString());
      params.append("firmId", userContext.firmId.toString());
      params.append("branchId", userContext.branchId.toString());
      params.append("pageIndex", parameters.pageIndex.toString());
      params.append("pageSize", parameters.pageSize.toString());
      params.append("sortColumn", parameters.sortColumn);
      params.append("sortDirection", parameters.sortDirection);
      params.append("searchValue", "");
      params.append("financialYear", userContext.financialYear?.toString());
      const result: any = await GetSupplierList(params);
      if (result && result.data && result.data.data) {
        supCollection = result.data.data.supplierCollection;
        setSourceSupplierCollection(supCollection);
      }
      return supCollection;
    } catch (e: any) {
      updateUserContext({
        ...userContext,
        isAlert: true,
        alertMessage:
          typeof e === "string" ? (e as string) : (e?.message as string),
        alertType: AlertType.Error,
      });
    }
  }

  const isSelected = (id: number) => selected.indexOf(id) !== -1;

  function searchValue(val: any) {
    if (val === "") {
      setValue("");
    }
    setPage_Index(1);
    setParam({ ...param, searchValue: val.toString(), pageIndex: 1 });
  }

  //for less than
  function lessThanValue(val: any) {
    if (val === "") {
      setValues("");
    }
    setPage_Index(1);
    setParam({ ...param, lessThanValue: val.toString(), pageIndex: 1 });
  }

  const handleChangePageNew = (
    event: React.ChangeEvent<unknown>,
    value: number
    //values: number
  ) => {
    if (Curr_page !== value) {
      setCurrPage(value);
      setPage_Index(value);
      setParam({ ...param, pageIndex: value });
    }
  };

  const StyledMenu = styled((props: MenuProps) => (
    <Menu
      elevation={0}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      {...props}
    />
  ))(({ theme }) => ({
    "& .MuiPaper-root": {
      borderRadius: 6,
      marginTop: theme.spacing(1),
      minWidth: 50,
      color:
        theme.palette.mode === "light"
          ? "rgb(55, 65, 81)"
          : theme.palette.grey[300],
      boxShadow:
        "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
      "& .MuiMenu-list": {
        padding: "4px 0",
      },
      "& .MuiMenuItem-root": {
        "& .MuiSvgIcon-root": {
          fontSize: 18,
          color: theme.palette.text.secondary,
          marginRight: theme.spacing(1.5),
        },
        "&:active": {
          backgroundColor: alpha(
            theme.palette.primary.main,
            theme.palette.action.selectedOpacity
          ),
        },
      },
    },
  }));

  async function openStockReportPopup(type: any) {
    setAnchorEl2(null);
    setLoading(true);
    let fileType = type === "pdf" ? ".pdf" : ".xls";

    let fileName = "BatchWiseStockReport" + fileType;
    let params = new URLSearchParams();
    params.append("reportName", "BatchWiseStockReport");
    params.append("reportType", type);
    params.append("consumerId", userContext.consumerId.toString());
    params.append("branchId", userContext.branchId.toString());
    params.append("firmId", userContext.firmId.toString());
    params.append("pageIndex", parameters.pageIndex.toString());
    params.append("pageSize", parameters.pageSize.toString());
    params.append("sortColumn", parameters.sortColumn);
    params.append("sortDirection", parameters.sortDirection);
    params.append("productCompanyIds", selectedProductCompanyIdData);
    params.append("isWarehouseEnable", reportConfig["WAREHOUSE"] ? "true" : "false");
    params.append("isCategoryEnable", reportConfig["CATEGORY"] ? "true" : "false");
    params.append("isOpeningEnable", reportConfig["OPENING"] ? "true" : "false");
    params.append("isInwardEnable", reportConfig["INWARD"] ? "true" : "false");
    params.append("isOutwardEnable", reportConfig["OUTWARD"] ? "true" : "false");
    params.append("searchValue", param.searchValue);
    params.append("isZeroAllowed", param.isZeroAllowed);
    params.append("lessThanValue", param.lessThanValue);
    params.append("productID", selectedProductIdData);
    params.append("financialYear", userContext.financialYear.toString());
    params.append("mode", "EXPORT");
    params.append("fileName", fileName);
    params.append("isForDownload", "1");
    try {
      const result: any = await GetStockBatchWiseListReport(params);
      if (result && result.data && result.data.data) {
        var fileContent = result?.data?.data?.fileData;
        var attachmentData = fileContent;
        ExportFilesFunction(fileName, type, attachmentData);
        setLoading(false);
      }
      setLoading(false);
    } catch (e: any) {
      // setLoading(false);
      updateUserContext({
        ...userContext,
        isAlert: true,
        alertMessage:
          typeof e === "string" ? (e as string) : (e?.message as string),
        alertType: AlertType.Error,
      });
    }
  }

  function useQuery() {
    const { search } = useLocation();

    return React.useMemo(() => new URLSearchParams(search), [search]);
  }

  let urlParams = useQuery();
  const edService = new EncryptDecryptService();
  let tempEncryptedConvertTimeCategoryId = urlParams.get("q");
  let decryptProductId: any = edService.decrypt(
    tempEncryptedConvertTimeCategoryId
  );
  let convertedProductId: any = parseInt(decryptProductId) || 0;
  // convertedProductId
  const handleChangeCategory = (object: any) => {
    setProductssSelectedOption(object);
    let tempProductIdData: any = [];
    object.forEach((x) => {
      if (x?.value === "*") {
        return;
      } else {
        let productIds = x.productId;
        x.productId = productIds;
        tempProductIdData.push(productIds.toString());
      }
    });
    setselectedProductIdData(tempProductIdData);
  };

  const handleSupplierChange = (object: any) => {
    setSelectedSupplierId(object);
    let tempSupplierIdData: any = [];
    object.forEach((x) => {
      if (x?.value === "*") {
        return;
      } else {
        let buyerIds = x?.supplierId;
        x.buyerId = buyerIds;
        tempSupplierIdData.push(buyerIds.toString());
      }
    });
    setSelectedSupplierIdData(tempSupplierIdData);
  };

  // async function handleMoveToStock(productId: any) {
  //     try {
  //         let encProductId: any = edService.encrypt(productId);
  //         navigate({
  //             pathname: "/stock",
  //             search: `?q=${encodeURIComponent(encProductId)}`,
  //         }, {
  //             state: { title: "Edit Category", button: "Update", productId: productId, isAddPopUp: "false" },
  //         });
  //     } catch (e: any) {
  //         updateUserContext({ ...userContext, isAlert: true, alertMessage: typeof e === 'string' ? e as string : e?.message as string, alertType: AlertType.Error });
  //     }
  // }
  const configurationSetting = React.useMemo(() => {
    return userContext?.systemConfigurationColl?.find(
      (item) =>
        item?.configModule === "BATCH_WISE_STOCK" &&
        item?.configKey === "SHOW_FIELDS"
    );
  }, [userContext?.systemConfigurationColl]);

  const reportConfigList = React.useMemo(() => {
    return (
      userContext?.systemConfigurationDetailColl?.filter(
        (item) =>
          item?.parentConfigurationModule === "BATCH_WISE_STOCK" &&
          item?.configModule === "SHOW_FIELDS"
      ) || []
    );
  }, [userContext?.systemConfigurationDetailColl, configurationSetting]);

  const [reportConfigDetail, setReportConfigDetail] = React.useState<any>(
    reportConfigList?.map((item) => {
      return { ...item, isChecked: item?.configValue === "1" };
    })
  );

  const reportConfig = React.useMemo(() => {
    return reportConfigDetail?.reduce((acc, item) => {
      acc[item.configKey] = item.isChecked;
      return acc;
    }, {});
  }, [reportConfigDetail]);

  const getSystemConfigurationById = async (configurationId: string) => {
    let params = new URLSearchParams();
    let configurationDetail: any = null;
    params.append("systemConfigurationId", configurationId?.toString() ?? "0");
    params.append("consumerId", userContext.consumerId.toString());
    params.append("firmId", userContext.firmId.toString());
    try {
      const result: any = await GetSystemConfigurationById(params);
      if (result?.data?.data) {
        configurationDetail = result.data.data;
      }
      return configurationDetail;
    } catch (e: any) {
      updateUserContext({

        ...userContext,
        isAlert: true,
        alertMessage:
          typeof e === "string" ? (e as string) : (e?.message as string),
        alertType: AlertType.Error,
      });
    }
  };


  const handleSettingsSave = async (configData) => {
    try {
      if ((configurationSetting?.masterSystemConfigurationId ?? 0) > 0) {
        const reportConfigDetailColl = configData?.map((config) => {
          if (config?.systemConfigurationDetailId > 0) {
            config.mode = "U";
          } else {
            config.mode = "I";
          }
          config.configValue = config.isChecked ? "1" : "0";
          return config;
        });

        let result: any = "";
        let formData = {
          systemConfigurationId:
            configurationSetting?.systemConfigurationId || 0,
          masterSystemConfigurationId:
            configurationSetting?.masterSystemConfigurationId || 0,
          consumerId: userContext?.consumerId,
          firmId: userContext?.firmId || 0,
          branchId: 0, // CAUSE OF MULTI BRANCH,
          userId: 0, // CAUSE OF MULTI UASER,
          isDeleted: configurationSetting?.isDeleted || false,
          dataManagedBy: userContext?.userId || 0,
          configModule: configurationSetting?.configModule || "",
          configValue: configurationSetting?.configValue || "",
          configKeyLabel: configurationSetting?.configKeyLabel || "",
          configKey: configurationSetting?.configKey || "",
          configDataType: configurationSetting?.configDataType || "",
          systemConfigurationDetailJson: JSON.stringify(
            reportConfigDetailColl || []
          ),
        };

        if ((configurationSetting?.systemConfigurationId ?? 0) > 0) {
          result = await UpdateConfiguration(formData);
        } else {
          result = await CreateConfiguration(formData);
        }

        if (result?.data) {
          const updatedConfig = await getSystemConfigurationById(
            result?.data?.systemConfigurationId || 0
          );
          setReportConfigDetail(configData);

          let systemConfigurationColl =
            userContext?.systemConfigurationColl?.map((item) => {
              if (
                item?.configModule === updatedConfig?.configModule &&
                item.configKey === updatedConfig?.configKey
              ) {
                return {
                  ...item,
                  systemConfigurationId: updatedConfig.systemConfigurationId,
                  configValue: updatedConfig.configValue,
                };
              }
              return item;
            });

          let systemConfigurationDetailColl =
            userContext?.systemConfigurationDetailColl?.map((detailItem) => {
              const match = updatedConfig?.systemConfigurationDetailColl?.find(
                (item) =>
                  item?.parentConfigurationModule ===
                  detailItem?.parentConfigurationModule &&
                  item?.configModule === detailItem?.configModule &&
                  item?.configKey === detailItem?.configKey
              );
              if (match) {
                return {
                  ...detailItem,
                  systemConfigurationId: match.systemConfigurationId,
                  systemConfigurationDetailId:
                    match.systemConfigurationDetailId,
                  masterSystemConfigurationId:
                    match.masterSystemConfigurationId,
                  configValue: match.configValue,
                };
              }
              return detailItem;
            });

          updateUserContext({
            ...userContext,
            isAlert: true,
            alertMessage: result?.message,
            alertType: AlertType.Success,
            systemConfigurationColl: systemConfigurationColl,
            systemConfigurationDetailColl: systemConfigurationDetailColl,
          });
        }
      } else {
        updateUserContext({
          ...userContext,
          isAlert: true,
          alertMessage: "Something went wrong.",
          alertType: AlertType.Error,
        });
      }
    } catch (e: any) {
      updateUserContext({
        ...userContext,
        isAlert: true,
        alertMessage:
          typeof e === "string" ? (e as string) : (e?.message as string),
        alertType: AlertType.Error,
      });
    }
  };


  function EnhancedTableHead(props: EnhancedTableProps) {

    const [reportConfigData, setReportConfigData] = React.useState(
      props?.reportConfigDetail
    );
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
      event.stopPropagation(); // prevent bubbling issues
      setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
      setAnchorEl(null);
    };

    // Sync internal state with prop changes
    useEffect(() => {
      setReportConfigData(props?.reportConfigDetail);
    }, [props?.reportConfigDetail]);

    return (
      // checkBox for Header
      <TableHead className="table-header-color">
        <TableRow>

          {/* PRODUCT - always visible (body also always shows) */}
          <TableCell
            sx={{
              display: {
                xs: "table-cell",
                sm: "table-cell",
                md: "table-cell",
                lg: "table-cell",
              },
              fontWeight: "bold",
              minWidth: "160px",
            }}
            align="left"
          >
            Product
          </TableCell>

          {/* UNIT - hidden on XS just like body */}
          <TableCell
            sx={{
              display: {
                xs: "table-cell",
                sm: "table-cell",
                md: "table-cell",
                lg: "table-cell",
              },
              fontWeight: "bold",
              minWidth: "160px",
            }}
            align="left"
          >
            Unit
          </TableCell>

          {/* CATEGORY - hidden on XS same as body */}
          {reportConfig["CATEGORY"] && (
            <TableCell
              sx={{
                display: {
                  xs: "table-cell",
                  sm: "table-cell",
                  md: "table-cell",
                  lg: "table-cell",
                },
                fontWeight: "bold",
                minWidth: "100px",
              }}
              align="left"
            >
              Category
            </TableCell>
          )}

          {/* WAREHOUSE - match body visibility */}
          {reportConfig["WAREHOUSE"] && (
            <TableCell
              sx={{
                display: {
                  xs: "table-cell",
                  sm: "table-cell",
                  md: "table-cell",
                  lg: "table-cell",
                },
                fontWeight: "bold",
                minWidth: "100px",
              }}
              align="left"
            >
              Warehouse
            </TableCell>
          )}

          {/* BATCH - hidden on XS same as body */}
          <TableCell
            sx={{
              display: {
                xs: "table-cell",
                sm: "table-cell",
                md: "table-cell",
                lg: "table-cell",
              },
              fontWeight: "bold",
              minWidth: "70px",
            }}
            align="center"
          >
            Batch
          </TableCell>

          {/* EXPIRY - hidden on XS same as body */}
          <TableCell
            sx={{
              display: {
                xs: "table-cell",
                sm: "table-cell",
                md: "table-cell",
                lg: "table-cell",
              },
              fontWeight: "bold",
              minWidth: "70px",
            }}
            align="center"
          >
            Expiry
          </TableCell>

          {/* OPENING - hidden on XS same as body */}
          {reportConfig["OPENING"] && (
            <TableCell
              sx={{
                display: {
                  xs: "table-cell",
                  sm: "table-cell",
                  md: "table-cell",
                  lg: "table-cell",
                },
                fontWeight: "bold",
                minWidth: "80px",
              }}
              align="right"
            >
              Opening
            </TableCell>
          )}

          {/* INWARD - hidden on XS */}
          {reportConfig["INWARD"] && (
            <TableCell
              sx={{
                display: {
                  xs: "table-cell",
                  sm: "table-cell",
                  md: "table-cell",
                  lg: "table-cell",
                },
                fontWeight: "bold",
                minWidth: "80px",
              }}
              align="right"
            >
              Inward
            </TableCell>
          )}

          {/* OUTWARD - hidden on XS */}
          {reportConfig["OUTWARD"] && (
            <TableCell
              sx={{
                display: {
                  xs: "table-cell",
                  sm: "table-cell",
                  md: "table-cell",
                  lg: "table-cell",
                },
                fontWeight: "bold",
                minWidth: "80px",
              }}
              align="right"
            >
              Outward
            </TableCell>
          )}

          {/* AVAILABLE - always visible same as body */}
          <TableCell
            sx={{
              display: {
                xs: "table-cell",
                sm: "table-cell",
                md: "table-cell",
                lg: "table-cell",
              },
              fontWeight: "bold",
              minWidth: "120px",
            }}
            align="right"
          >
            Available
          </TableCell>
          <TableCell
            sx={{
              display: {
                xs: "table-cell",
                sm: "table-cell",
                md: "table-cell",
                lg: "table-cell",
              },
              fontWeight: "bold",
              minWidth: "120px",
            }}
            align="right"
          >
            Units
          </TableCell>   
          <TableCell
            sx={{
              display: {
                xs: "table-cell",
                sm: "table-cell",
                md: "table-cell",
                lg: "table-cell",
              },
              fontWeight: "bold",
              minWidth: "120px",
            }}
            align="right"
          >
            Rate ₹
          </TableCell>
          <TableCell
            align="right"
            sx={{
              fontWeight: "bold",
              minWidth: 120,
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
                gap: 0.5,
              }}
            >
              <Typography
                variant="body2"
                sx={{ fontWeight: "bold" }}
              >
                Stock Value ₹
              </Typography>

              <BootstrapTooltip
                title="Weighted Average Cost"
                arrow
                placement="top"
              >
                <IconButton
                  size="small"
                  sx={{
                    padding: 0.5,
                  }}
                >
                  <HelpOutlineIcon
                    fontSize="small"
                    color="primary"
                  />
                </IconButton>
              </BootstrapTooltip>
            </Box>
          </TableCell>

          {/* SETTINGS BUTTON - body hides last empty column on XS */}
          <TableCell align="right">
            <Tooltip title="Customize Columns" placement="top">
              <IconButton aria-label="Settings" onClick={handleOpen} sx={{ p: 0 }} disableRipple>
                <img src={CustomColumn} alt="Settings" height={20} />
              </IconButton>
            </Tooltip>
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleClose}
              MenuListProps={{ disablePadding: true }}
              anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
              transformOrigin={{ vertical: "top", horizontal: "right" }}
            >
              <MenuList sx={{ padding: 0 }}>
                <Box
                  sx={{
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                    display: "flex",
                    flexDirection: "column",
                    overflow: "hidden",
                  }}
                >
                  <Box sx={{ backgroundColor: "#dee6fa", color: "#404d54", padding: "10px", fontWeight: "bold" }}>
                    Settings
                  </Box>

                  <Box sx={{ maxHeight: "300px", overflowY: "auto" }}>
                    {reportConfigData?.map((item, index) => (
                      <MenuItem
                        key={index}
                        sx={{
                          alignItems: "start",
                          paddingLeft: "5px",
                        }}
                        onClick={(e) => {
                          if (item?.isLocked) return;
                          setReportConfigData((prev) =>
                            prev.map((x) =>
                              x.configKey === item?.configKey
                                ? {
                                  ...x,
                                  isChecked: !item?.isChecked,
                                }
                                : x
                            )
                          );
                        }}
                      >
                        {item?.isLocked ? (
                          <LockIcon />
                        ) : (
                          <Checkbox
                            checked={item?.isChecked}
                            sx={{
                              padding: 0,
                              margin: 0,
                            }}
                          />
                        )}

                        <Typography sx={{ fontSize: "13px !important", paddingLeft: "8px", fontWeight: "normal" }}>
                          {item?.configKeyLabel}
                        </Typography>
                      </MenuItem>
                    ))}
                  </Box>

                  <Box sx={{ display: "flex", justifyContent: "flex-end", borderTop: "1px solid #ccc", gap: "5px", px: 2, py: 1 }}>
                    <Button
                      size="small"
                      onClick={() => {
                        handleSettingsSave(reportConfigData);
                        setAnchorEl(null);
                      }}
                      color="primary"
                      variant="contained"
                    >
                      Save
                    </Button>
                    <Button size="small" onClick={handleClose}>Close</Button>
                  </Box>
                </Box>
              </MenuList>
            </Menu>
          </TableCell>
        </TableRow>
      </TableHead>

    );
  }

  useEffect(() => {
    GetProductListforBatchwise();
    GetSuppliersList();
    fetchProductCompanyList();
    fetchStockList();
    setSelected([]);
    let e: any = document.getElementById("root");
    e.scrollIntoView({
      block: "start",
      behavior: "smooth",
      inline: "start",
    });
  }, [param, selectedProductIdData, selectedSupplierIdData, selectedProductCompanyIdData]);

  useEffect(() => {
    const productId = async () => {
      const productData = await GetProductListforBatchwise();
      if (convertedProductId > 0 && convertedProductId) {
        const filteroption: any = productData?.filter((x) => {
          return x.productId === convertedProductId;
        });
        setProductssSelectedOption(filteroption);
        setselectedProductIdData(convertedProductId.toString());
        handleChangeCategory(filteroption);
      } else {
      }
    };

    productId();
  }, []);

  return (
    <>
      <Backdrop
        sx={{
          color: "#fff",
          backgroundColor: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
        open={isLoading}
      >
        <SplashComponent />
      </Backdrop>
      <Title pageTitle="batch-wise-stock" />

      {userContext.consumerId > 0 ? (
        <Box
          className="boxContainer"
          sx={{
            "& > :not(style)": {
              width: "100%",
            },
          }}
        >
          <Grid
            className="title-button-responsive"
            item
            xs={6}
            md={3}
            sx={{
              display: "flex !important",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <h4 className="page-title">Batch Wise Stock</h4>
            <Grid
              item
              xs={6}
              md={3}
              marginRight={0}
              textAlign="end"
              paddingTop="0px"
            >
              <Button
                // color="primary"
                variant="outlined"
                onClick={() => navigate(-1)}
                size="medium"
                disabled={!isAllowAdd}
              >
                <ShortcutButton label="ESC" />
                Back
              </Button>
            </Grid>
          </Grid>
          <Grid className="paper top-space">
            <Paper elevation={4} className="paper-container">
              <Grid container spacing={1}>
                <Grid item xs={12} sm={6} md={6}>
                  <MultiSelectSim
                    key="productId"
                    placeholderLabel="Products"
                    placeholder="Select Product.."
                    options={productCollection}
                    onChange={handleChangeCategory}
                    value={productsSelectedOption}
                    isSelectAll={true}
                    menuPlacement={"bottom"}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                  <AsyncSelect
                    menuPortalTarget={document.querySelector("body")}
                    cacheOptions
                    loadOptions={loadFilterCompanyOptions}
                    isClearable
                    isSearchable
                    isMulti
                    components={animatedComponents}
                    placeholder={"Company/Brand Name *"}
                    value={selectedCompanies}
                    defaultOptions={
                      productCompanyCollection !== undefined &&
                      productCompanyCollection
                        .map((item) => ({
                          ...item,
                          value: item.value,
                        }))
                        .slice(0, 5)
                    }
                    theme={(theme) => ({
                      ...theme,
                      colors: {
                        ...theme.colors,
                        primary: "#25258f",
                        primary25: "#ecebef",
                        primary50: "#e1dfea",
                      },
                    })}
                    noOptionsMessage={() =>
                      inputCompanyValue.length > 0
                        ? "Company not found"
                        : "Enter text to find company"
                    }
                    onInputChange={(value) => {
                      const inputValue = value.trim();
                      setInputCompanyValue(inputValue);
                      return inputValue;
                    }}
                    onChange={(selectedOptions: any[]) => {
                      setSelectedCompanies(selectedOptions || []);

                      // If you need only IDs
                      const selectedIds = selectedOptions
                        ? selectedOptions.map((opt) => opt.value)
                        : [];

                      setSelectedProductCompanyIdData(selectedIds);
                    }}
                  />
                </Grid>
              </Grid>
              <Grid
                container
                spacing={1}
                sx={{ marginTop: "10px" }}
                className="search-space"
              >
                <Grid item xs={12} sm={6} md={3} lg={2} xl={2}>
                  <TextField
                    onKeyPress={(e) => {
                      if (e.key === "Enter") {
                        searchValue(value);
                      }
                    }}
                    sx={{ paddingLeft: "0px !important", width: "100%" }}
                    className="button-responsive-stock"
                    placeholder="Search..."
                    type="text"
                    variant="outlined"
                    size="small"
                    onChange={(e) => setValue(e.target.value)}
                    value={value}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="end">
                          <IconButton onClick={() => searchValue(value)}>
                            <SearchIcon />
                          </IconButton>
                        </InputAdornment>
                      ),

                      endAdornment: value && (
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={() => searchValue("")}
                        >
                          <ClearIcon />
                        </IconButton>
                      ),
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={3} lg={2} xl={2}>
                  <TextField
                    onKeyPress={(e) => {
                      if (e.key === "Enter") {
                        lessThanValue(values);
                      }
                    }}
                    sx={{ width: "100%" }}
                    className="button-responsive-stock"
                    placeholder="Stock is less than..."
                    type="number"
                    variant="outlined"
                    size="small"
                    onChange={(e) => setValues(e.target.value)}
                    value={values}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="end">
                          <IconButton onClick={() => lessThanValue(values)}>
                            <SearchIcon />
                          </IconButton>
                        </InputAdornment>
                      ),

                      endAdornment: values && (
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={() => lessThanValue("")}
                        >
                          <ClearIcon />
                        </IconButton>
                      ),
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={6.5} xl={6.5}>
                  <Grid
                    sx={{
                      width: "100%",
                      height: "100%",
                      display: "flex",
                      justifyContent: "end",
                      alignItems: "center",
                    }}
                  >
                    <Typography component={"span"} variant="inherit">
                      <Checkbox
                        name="isZeroAllowed"
                        value={param.isZeroAllowed}
                        onChange={(event) => {
                          setParam({
                            ...param,
                            isZeroAllowed: event.target.checked,
                          });
                        }}
                      />
                      Include Zero Quantity Available
                    </Typography>
                  </Grid>
                </Grid>
                <Grid item xs={12} sm={6} md={2} lg={1.5} xl={1.5}>
                  <Grid
                    sx={{
                      height: "100%",
                      display: "flex",
                      justifyContent: "end",
                      alignItems: "center",
                    }}
                  >
                    <Button
                      className="button-responsive-stock"
                      aria-controls={
                        openExportType ? "demo-customized-menu" : undefined
                      }
                      aria-haspopup="true"
                      aria-expanded={openExportType ? "true" : undefined}
                      disabled={
                        resultData?.batchWiseListCollection.length <= 0
                          ? true
                          : false
                      }
                      variant="outlined"
                      //size="large"
                      //sx={{ height: "43px" }}
                      disableElevation
                      onClick={handleClickExportType}
                      startIcon={<DownloadIcon />}
                      endIcon={<KeyboardArrowDownSharp />}
                    >
                      Export
                    </Button>
                    <StyledMenu
                      id="demo-customized-menu"
                      MenuListProps={{
                        "aria-labelledby": "demo-customized-button",
                      }}
                      anchorEl={anchorEl2}
                      open={openExportType}
                      onClose={handleCloseExportType}
                    >
                      <MenuItem
                        disableRipple
                        onClick={() => {
                          openStockReportPopup("pdf");
                        }}
                      >
                        PDF
                      </MenuItem>
                      <MenuItem
                        disableRipple
                        onClick={() => {
                          openStockReportPopup("Excel");
                        }}
                      >
                        EXCEL
                      </MenuItem>
                    </StyledMenu>
                  </Grid>
                </Grid>
              </Grid>

              <TableContainer>
                <Table size={dense ? "small" : "medium"}>

                  <EnhancedTableHead
                    numSelected={selected.length}
                    order={order}
                    orderBy={orderBy}
                    rowCount={resultData?.batchWiseListCollection.length}
                    reportConfigDetail={reportConfigDetail}
                  />

                  <TableBody>
                    {stableSort(resultData?.batchWiseListCollection, getComparator(order, orderBy))
                      .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                      .map((item, index) => (
                        <TableRow hover key={index}>

                          {/* PRODUCT */}
                          <TableCell sx={{ fontWeight: "bold" }}>{item.productName}</TableCell>

                          {/* UNIT */}
                          <TableCell>{item.unitName}</TableCell>

                          {/* CATEGORY */}
                          {reportConfig["CATEGORY"] && (
                            <TableCell>{item.categoryName}</TableCell>)}

                          {/* WAREHOUSE */}
                          {reportConfig["WAREHOUSE"] && (
                            <TableCell>{item.warehouseName}</TableCell>)}

                          {/* BATCH */}
                          <TableCell align="center">{item.batchNumber}</TableCell>

                          {/* EXPIRY */}
                          <TableCell align="center">{item.expiryDate}</TableCell>

                          {/* OPENING */}
                          {reportConfig["OPENING"] && (
                            <TableCell align="right">{numberFormat(item?.openingQuantity, 3, 3)}</TableCell>
                          )}

                          {/* INWARD */}
                          {reportConfig["INWARD"] && (
                            <TableCell align="right">{numberFormat(item?.inward, 3, 3)}</TableCell>
                          )}

                          {/* OUTWARD */}
                          {reportConfig["OUTWARD"] && (
                            <TableCell align="right">{numberFormat(item?.outward, 3, 3)}</TableCell>
                          )}

                          {/* AVAILABLE */}
                          <TableCell
                            sx={{
                              display: {
                                fontWeight: "bold"
                              },
                            }}
                            align="right"
                            className={
                              item?.availabelQuantity <= 0
                                ? "red-color"
                                : item?.availabelQuantity <= 10
                                  ? "blue-color"
                                  : ""
                            }
                          >
                            {numberFormat(item?.availabelQuantity, 3, 3)} 
                            </TableCell>

                            <TableCell
                              sx={{
                                minWidth: "90px",
                              }}
                              align="right"
                            >
                            {(() => {
                              const unit =
                                item.unitTypeCode === "COMPOUND"
                                  ? item.firstUnitCode || item.firstUnitName
                                  : item.enableAlternateUnit
                                    ? item.alternateUnitCode || item.alternateUnitName
                                    : item.unitCode || item.unitName;

                              const clean = (unit || "").toString().trim();

                              return clean;
                            })()}
                          </TableCell>

                          <TableCell
                            sx={{
                              display: {
                                xs: "table-cell",
                                sm: "table-cell",
                                md: "table-cell",
                              },
                            }}
                            align="right"
                            className={
                              item?.rate <= 0
                                ? "red-color"
                                : ""
                            }
                          >
                            {numberFormat(item?.rate)}
                          </TableCell>
                          <TableCell
                            sx={{
                              display: {
                                xs: "table-cell",
                                sm: "table-cell",
                                md: "table-cell",
                              },
                            }}
                            align="right"
                            className={
                              item?.stockValue <= 0
                                ? "red-color"
                                : ""
                            }
                          >
                            {numberFormat(item?.stockValue)}
                          </TableCell>

                          {/* FLEX FILL COLUMN */}
                          <TableCell></TableCell>
                        </TableRow>
                      ))}

                    {/* TOTAL ROW */}
                    {resultData?.batchWiseListCollection.length > 0 && (
                      <TableRow hover>
                        <TableCell className="bold-600">Total</TableCell>

                        <TableCell
                          colSpan={
                            2 +                                  // your two <TableCell></TableCell>
                            (reportConfig["WAREHOUSE"] ? 1 : 0) +
                            (reportConfig["CATEGORY"] ? 1 : 0) +
                            (userContext.enableBatchwiseTax ? 1 : 0)
                          }
                        />

                        {reportConfig["OPENING"] && (
                          <TableCell align="right" className="bold-600">
                            {numberFormat(resultData.batchWiseListCollection.reduce((a, b) => a + (b?.openingQuantity || 0), 0), 3, 3)}
                          </TableCell>
                        )}

                        {reportConfig["INWARD"] && (
                          <TableCell align="right" className="bold-600">
                            {numberFormat(resultData.batchWiseListCollection.reduce((a, b) => a + (b?.inward || 0), 0), 3, 3)}
                          </TableCell>
                        )}

                        {reportConfig["OUTWARD"] && (
                          <TableCell align="right" className="bold-600">
                            {numberFormat(resultData.batchWiseListCollection.reduce((a, b) => a + (b?.outward || 0), 0), 3, 3)}
                          </TableCell>
                        )}

                        <TableCell align="right" className="bold-600">
                          {numberFormat(resultData.batchWiseListCollection.reduce((a, b) => a + (b?.availabelQuantity || 0), 0), 3, 3)}
                        </TableCell>

                        <TableCell></TableCell>
                        <TableCell align="right" className="bold-600 ">
                          {numberFormat(
                            resultData?.batchWiseListCollection?.reduce(
                              (acc, curr) =>
                                acc +
                                (curr?.stockValue
                                  ? curr?.stockValue
                                  : 0),
                              0
                            )
                          )}
                        </TableCell>

                        {/* FLEX FILL FOOTER COLUMN */}
                        <TableCell></TableCell>
                      </TableRow>
                    )}

                    {/* NO RECORDS */}
                    {resultData.batchWiseListCollection.length <= 0 ? (
                      <TableRow hover tabIndex={-1} key={"0"}>
                        <TableCell colSpan={8} align="center">
                          No record(s) found
                        </TableCell>
                      </TableRow>
                    ) : (
                      <></>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
              {resultData.length <= 0 ? (
                <></>
              ) : (
                <>
                  {matches ? (
                    <Grid
                      container
                      paddingTop={1}
                      alignItems={"center"}
                      justifyContent={"center"}
                    >
                      <Grid item xs={12} sm={6} className="pagination-label">
                        {pageStartIndex} - {pageEndIndex} of {totalCount}
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Stack
                          component="div"
                          alignItems={matches ? "center" : "end"}
                          justifyContent={"center"}
                        >
                          <Pagination
                            color="primary"
                            count={counData}
                            page={page_Index}
                            onChange={handleChangePageNew}
                          />
                        </Stack>
                      </Grid>
                    </Grid>
                  ) : (
                    <Grid
                      container
                      paddingTop={1}
                      alignItems={"center"}
                      justifyContent={"center"}
                    >
                      <Grid item xs={6} className="pagination-label">
                        {pageStartIndex} - {pageEndIndex} of {totalCount}
                      </Grid>
                      <Grid item xs={6}>
                        <Stack
                          component="div"
                          alignItems={"end"}
                          justifyContent={"center"}
                        >
                          <Pagination
                            color="primary"
                            count={counData}
                            page={page_Index}
                            onChange={handleChangePageNew}
                          />
                        </Stack>
                      </Grid>
                    </Grid>
                  )}
                </>
              )}
            </Paper>
          </Grid>
        </Box>
      ) : (
        // <Box
        //   className="boxContainer"
        //   sx={{
        //     "& > :not(style)": {
        //       width: "100%",
        //     },
        //   }}
        // >
        <MissingConsumer consumerId={userContext.consumerId} />
        // </Box>
      )}
    </>
  );
}
